import { Action } from "@ngrx/store";
import { Contract } from "@edp-components/edp-contract";
import { PendingContract } from "@edp-models/edp-pending-contract.model";
import { PartnerInfo } from "@edp-models/edp-partner-info.model";
import { PaymentReference } from "@edp-models/edp-payment-reference.model";
import { ITotalDiscountsByContract } from "@edp-models/total-discount-contract.model";
import { ContractDetails } from "@edp-components/edp-contract/edp-contract-details.model";
import { ComplementaryInfoContract, ComplementaryInfoForm } from "@edp-models/complementary-info.model";
import {
    ContractChange,
    ContractDiscounts,
    ContractNewTariffs,
    ContractedService,
    ContractTariffsMapping,
    IContractFilter,
    WallboxService
} from "@edp-components/edp-contract/edp-contract.model";
import { ICustomUrl } from "@edp-models/deep-link.model";
import { ICheckUpCard } from "@edp-pages/service-funciona/review-check-up/review-check-up.model";
import { Address, PostalCode } from "@edp-models/postal-code.model";
import { Pack } from "@edp-components/edp-pack";
import { BusinessAgrementStatusAPI } from "@edp-models/business-agrements.model";

export enum EContractActions {
    GetContracts = "[Contract] Get Contracts",
    SetContracts = "[Contract] Set Contracts",
    GetContractDetails = "[Contract] Get Contract Details",
    SetContractDetails = "[Contract] Set Contract Details",
    ContractDetailsAPIError = "[Contract] Set Contract Details API error",
    SelectContract = "[Contract] Select Contract",
    SelectedContractAPIError = "[Contract] Get Contract API error",
    ClearSelectedContractData = "[Contract] Clear Selected Contract Data",
    IsSingleContract = "[Contract] Is Single Contract",
    SetTotalDiscount = "[Contract] Set TotalDiscount",
    GetContractManagers = "[Contract] Get ContractManagers",
    GetPendingContracts = "[Contract] Get Pending Contracts",
    SetPendingContracts = "[Contract] Set Pending Contracts",
    GetPartnerInfo = "[Contract] Get Partner Info",
    SetPartnerInfo = "[Contract] Set Partner Info",
    PartnerInfoAPIError = "[Contract] Get Partner Info API error",
    GetPaymentReference = "[Contract] Get Payment Reference",
    GetPaymentReferenceError = "[Contract] Get Payment Reference Error",
    SetPaymentReference = "[Contract] Set Payment Reference",
    SetPaymentReferenceError = "[Contract] Set Payment Reference Error",
    GetTotalDiscountsByContract = "[Contract] Get TotalDiscount By Contract",
    SetTotalDiscountsByContract = "[Contract] Set TotalDiscount By Contract",
    FlagContractRating = "[Contract] Flag Contract Rating",
    GetComplementaryInfo = "[Contract] Get Complementary Info",
    SetComplementaryInfo = "[Contract] Set Complementary Info",
    SendComplementaryInfoForm = "[Contract] Send Complementary Info Form",
    ShowContractSelection = "[Contract] Show Contract Selection",
    HideContractSelection = "[Contract] Hide Contract Selection",
    SetUrlToRedirect = "[Contract] Set Url to Redirect to",
    GetContractFilters = "[Contract] Get Filters",
    SetContractFilters = "[Contract] Set Filters",
    GetCheckupCards = "[Contract] Get Checkup Cards",
    SetCheckupCards = "[Contract] Set Checkup Cards",
    GetBusinessAgrements = "[Contract] Get Business Agrements",
    SetBusinessAgrements = "[Contract] Set Business Agrements",
    UdpateBusinessAgrements = "[Contract] Update Business Agrements",
    UpdateBusinessAgrementsStatus = "[Contract] Update Business Agrements Status",
    SetContractChanges = "[Contract] Set Contract Changes",
    GetAddressList = "[Contract] Get Address List",
    SetAddressList = "[Contract] Set Address List",
    GetTariffsMappings = "[Contract] Get Tariffs Mappings",
    SetTariffsMappings = "[Contract] Set Tariffs Mappings",
    GetNewContractTariffs = "[Contract] Get New Tariffs",
    SetNewContractTariffs = "[Contract] Set New Tariffs",
    GetPacks = "[Contract] Get Packs",
    SetPacks = "[Contract] Set Packs",
    SetPack = "[Contract] Set Pack",
    GetPack = "[Contract] Get Pack",
    GetDiscounts = "[Contract] Get Discounts",
    SetDiscounts = "[Contract] Set Discounts",
    GetAlerts = "[Contract] Get Alerts",
    SetAlerts = "[Contract] Set Alerts",
    GetContractedServices = "[Contract] Get Contracted Services",
    SetContractedServices = "[Contract] Set Contracted Services",
    GetWallBoxService = "[Contract] Get Wallbox Service",
    SetWallBoxService = "[Contract] Set Wallbox Service",
}

export class GetContracts implements Action {
    public readonly type = EContractActions.GetContracts;
    constructor(public forceSync?: boolean) {}
}

export class SetContracts implements Action {
    public readonly type = EContractActions.SetContracts;
    constructor(public payload: Contract[]) {}
}

export class GetContractDetails implements Action {
    public readonly type = EContractActions.GetContractDetails;
    constructor(public contract: Contract) {}
}

export class SetContractDetails implements Action {
    public readonly type = EContractActions.SetContractDetails;
    constructor(public payload: ContractDetails) {}
}

export class ContractDetailsAPIError implements Action {
    public readonly type = EContractActions.ContractDetailsAPIError;
    constructor(public error: Error) {}
}

export class GetContractManagers implements Action {
    public readonly type = EContractActions.GetContractManagers;
    constructor(public payload: any) {}
}

export class SelectContract implements Action {
    public readonly type = EContractActions.SelectContract;
    constructor(public contract: Contract) {}
}

export class ClearSelectedContractData implements Action {
    public readonly type = EContractActions.ClearSelectedContractData;
}

export class SelectedContractAPIError implements Action {
    public readonly type = EContractActions.SelectedContractAPIError;
    constructor(public error: Error) {}
}

export class IsSingleContract implements Action {
    public readonly type = EContractActions.IsSingleContract;
    constructor(public payload: boolean) {}
}

export class SetTotalDiscount implements Action {
    public readonly type = EContractActions.SetTotalDiscount;
    constructor(public payload: number) {}
}

export class GetPendingContracts implements Action {
    public readonly type = EContractActions.GetPendingContracts;
}

export class SetPendingContracts implements Action {
    public readonly type = EContractActions.SetPendingContracts;
    constructor(public payload: PendingContract[]) {}
}

export class GetPartnerInfo implements Action {
    public readonly type = EContractActions.GetPartnerInfo;
    constructor(public contract: Contract) {}
}

export class SetPartnerInfo implements Action {
    public readonly type = EContractActions.SetPartnerInfo;
    constructor(public payload: PartnerInfo) {}
}

export class PartnerInfoAPIError implements Action {
    public readonly type = EContractActions.PartnerInfoAPIError;
    constructor(public error: Error) {}
}

export class GetPaymentReference implements Action {
    public readonly type = EContractActions.GetPaymentReference;
    constructor(public contract: Contract) {}
}

export class GetPaymentReferenceError implements Action {
    public readonly type = EContractActions.GetPaymentReferenceError;
    constructor(public contract: Contract) {}
}

export class SetPaymentReference implements Action {
    public readonly type = EContractActions.SetPaymentReference;
    constructor(public payload: PaymentReference) {}
}

export class SetPaymentReferenceError implements Action {
    public readonly type = EContractActions.SetPaymentReferenceError;
    constructor(public error: Error) {}
}

export class GetTotalDiscountsByContract implements Action {
    public readonly type = EContractActions.GetTotalDiscountsByContract;
}

export class SetTotalDiscountsByContract implements Action {
    public readonly type = EContractActions.SetTotalDiscountsByContract;
    constructor(public payload: ITotalDiscountsByContract) {}
}

export class FlagContractRating implements Action {
    public readonly type = EContractActions.FlagContractRating;
}

export class GetComplementaryInfo implements Action {
    public readonly type = EContractActions.GetComplementaryInfo;
}

export class SetComplementaryInfo implements Action {
    public readonly type = EContractActions.SetComplementaryInfo;
    constructor(public payload: ComplementaryInfoContract[]) {}
}

export class SendComplementaryInfoForm implements Action {
    public readonly type = EContractActions.SendComplementaryInfoForm;
    constructor(public payload: any) {}
}
export class ShowContractSelection implements Action {
    public readonly type = EContractActions.ShowContractSelection;
}

export class HideContractSelection implements Action {
    public readonly type = EContractActions.HideContractSelection;
}

export class SetUrlToRedirect implements Action {
    public readonly type = EContractActions.SetUrlToRedirect;
    constructor(public payload: ICustomUrl) {}
}

export class GetContractFilters implements Action {
    public readonly type = EContractActions.GetContractFilters;
}
export class SetContractFilters implements Action {
    public readonly type = EContractActions.SetContractFilters;
    constructor(public payload: IContractFilter[]) {}
}

export class GetCheckupCards implements Action {
    public readonly type = EContractActions.GetCheckupCards;
    constructor(public contract: Contract) {}
}

export class SetCheckupCards implements Action {
    public readonly type = EContractActions.SetCheckupCards;
    constructor(public payload: ICheckUpCard[]) {}
}

export class GetBusinessAgrements implements Action {
    public readonly type = EContractActions.GetBusinessAgrements;
    constructor(public payload: any) {}
}

export class SetBusinessAgrements implements Action {
    public readonly type = EContractActions.SetBusinessAgrements;
    constructor(public payload: any) {}
}
export class UdpateBusinessAgrements implements Action {
    public readonly type = EContractActions.UdpateBusinessAgrements;
    constructor(public payload: any) {}
}

export class UpdateBusinessAgrementsStatus implements Action {
    public readonly type = EContractActions.UpdateBusinessAgrementsStatus;
    constructor(public status: BusinessAgrementStatusAPI) {}
}

export class SetContractChanges implements Action {
    public readonly type = EContractActions.SetContractChanges;
    constructor(public payload: ContractChange) {}
}

export class GetAddressList implements Action {
    public readonly type = EContractActions.GetAddressList;
    constructor(public payload: PostalCode) {}
}

export class SetAddressList implements Action {
    public readonly type = EContractActions.SetAddressList;
    constructor(public payload: Address[]) {}
}

export class GetTariffsMappings implements Action {
    public readonly type = EContractActions.GetTariffsMappings;
}

export class SetTariffsMappings implements Action {
    public readonly type = EContractActions.SetTariffsMappings;
    constructor(public payload: ContractTariffsMapping) {}
}

export class GetNewContractTariffs implements Action {
    public readonly type = EContractActions.GetNewContractTariffs;
}

export class SetNewContractTariffs implements Action {
    public readonly type = EContractActions.SetNewContractTariffs;
    constructor(public payload: ContractNewTariffs) {}
}

export class GetPacks implements Action {
    public readonly type = EContractActions.GetPacks;

    constructor(public contract_id?: string ) {}
}

export class SetPacks implements Action {
    public readonly type = EContractActions.SetPacks;
    constructor(public payload: Pack[]) {}
}

export class GetPack implements Action {
    public readonly type = EContractActions.GetPack;
}

export class SetPack implements Action {
    public readonly type = EContractActions.SetPack;
    constructor(public payload: Pack) {}
}

export class GetDiscounts implements Action {
    public readonly type = EContractActions.GetDiscounts;
    constructor(public payload: any) {}
}

export class SetDiscounts implements Action {
    public readonly type = EContractActions.SetDiscounts;
    constructor(public payload: ContractDiscounts) {}
}

export class GetContractedServices implements Action {
    public readonly type = EContractActions.GetContractedServices;
    constructor(public payload: string) {}
}

export class SetContractedServices implements Action {
    public readonly type = EContractActions.SetContractedServices;
    constructor(public payload: ContractedService[]) {}
}

export class GetWallBoxService implements Action {
    public readonly type = EContractActions.GetWallBoxService;
    constructor(public payload: string) {}
}

export class SetWallBoxService implements Action {
    public readonly type = EContractActions.SetWallBoxService;
    constructor(public payload: WallboxService) {}
}

export class GetAlerts implements Action {
    public readonly type = EContractActions.GetAlerts;
    constructor(public payload: string) {}
}

export class SetAlerts implements Action {
    public readonly type = EContractActions.SetAlerts;
    constructor(public payload: any) {}
}

export type ContractActions =
    | GetContracts
    | SetContracts
    | SelectContract
    | SelectedContractAPIError
    | ClearSelectedContractData
    | IsSingleContract
    | SetTotalDiscount
    | GetPendingContracts
    | SetPendingContracts
    | GetPartnerInfo
    | SetPartnerInfo
    | PartnerInfoAPIError
    | GetPaymentReference
    | GetPaymentReferenceError
    | SetPaymentReference
    | SetPaymentReferenceError
    | GetTotalDiscountsByContract
    | SetTotalDiscountsByContract
    | GetContractDetails
    | SetContractDetails
    | ContractDetailsAPIError
    | FlagContractRating
    | GetComplementaryInfo
    | SetComplementaryInfo
    | SendComplementaryInfoForm
    | ShowContractSelection
    | HideContractSelection
    | SetUrlToRedirect
    | GetContractFilters
    | SetContractFilters
    | GetCheckupCards
    | SetCheckupCards
    | GetBusinessAgrements
    | SetBusinessAgrements
    | UdpateBusinessAgrements
    | UpdateBusinessAgrementsStatus
    | SetContractChanges
    | GetAddressList
    | SetAddressList
    | GetTariffsMappings
    | SetTariffsMappings
    | GetNewContractTariffs
    | SetNewContractTariffs
    | GetPacks
    | SetPacks
    | GetPack
    | SetPack
    | GetDiscounts
    | SetDiscounts
    | GetAlerts
    | SetAlerts
    | GetContractedServices
    | SetContractedServices
    | GetWallBoxService
    | SetWallBoxService;
